import React from 'react';
import { Card } from './ui/card';
import { Star, Quote } from 'lucide-react';

export const Testimonials = ({ t }) => {
  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-white to-slate-50 relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#001f3f] mb-4">
            {t.testimonials.title}
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            {t.testimonials.subtitle}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {t.testimonials.items.map((testimonial, index) => (
            <Card 
              key={`testimonial-${testimonial.name}-${index}`}
              className="group relative bg-white border-slate-200 hover:border-[#D4AF37] transition-all duration-500 overflow-hidden hover:shadow-2xl hover:-translate-y-2 hover:scale-105"
            >
              {/* Quote Icon Background */}
              <div className="absolute top-4 right-4 opacity-5 group-hover:opacity-10 group-hover:rotate-12 transition-all duration-500">
                <Quote className="w-24 h-24 text-[#D4AF37]" />
              </div>

              <div className="p-8 relative z-10">
                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={`star-${testimonial.name}-${i}`} className="w-5 h-5 fill-[#D4AF37] text-[#D4AF37] group-hover:scale-110 transition-transform duration-300" style={{ transitionDelay: `${i * 50}ms` }} />
                  ))}
                </div>

                {/* Content */}
                <p className="text-slate-700 leading-relaxed mb-6 italic">
                  "{testimonial.content}"
                </p>

                {/* Author */}
                <div className="border-t border-slate-200 pt-4">
                  <div className="font-bold text-[#001f3f]">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-slate-500">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
